/* Layout types and other constants */

export const LAYOUT_HORIZONTAL = 'topnav';

export const LAYOUT_WIDTH_FLUID = 'fluid';

export const LEFT_SIDEBAR_THEME_DEFAULT = 'default';

export const LEFT_SIDEBAR_TYPE_FIXED = 'fixed';
